export default __webpack_public_path__ + "static/media/ic_optimism_40.64811e7e.png";